var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showGuide && _vm.show)?_c('div',{staticClass:"newer-guide"},[_c('img',{staticClass:"newer-guide__img",attrs:{"src":_vm.hasLogin ? require('../img/login-321c8.png') : require('../img/login-321c8.png'),"alt":"新手指南"}}),_c('div',{staticClass:"newer-guide__close",on:{"click":_vm.closeGuide}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-634441d2","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigator/guide/guide.vue
// module id = 919
// module chunks = 1